<script>

    import { toast } from 'bulma-toast'

    import WalletsService from '../$services/wallets.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import Search from '../$components/input.search.svelte'
    import Table from '../$components/table.svelte'
    import Form from '../$components/form.svelte'
    import Button from '../$components/button.svelte'

    let wallets = []
    let metadata = {}
    let loading = false
    let reportLoading = false
    let element = null
    let query = {
        page: 0,
        find: null,
    }

    getWallets()

    async function getWallets() {

        loading = true
        const resp = await WalletsService.getWallets(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        wallets = resp.data.wallets
        metadata = resp.data.metadata
    }

    async function getWalletsReport() {

        reportLoading = true
        const blob = await WalletsService.getWalletsReport()
        reportLoading = false

        if(!blob)
            return toast({message: 'Error al descargar el reporte', type: 'is-danger'})

        element.download = 'saldos.xlsx'
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<a bind:this={element} href="/" style="display: none;">.</a>

<Table
    items={ wallets.length }
    total={ metadata.total }
    { loading }
    skeletonCols={3}
    bind:metadata
    bind:page={ query.page }
    on:change={ getWallets }
>
    <div slot="header" class="header-filters">
        <div class="header-top">
            <Search bind:value={ query.find } on:enter={ getWallets } />
            <Form on:submit={getWalletsReport} loading={reportLoading}>
                <Button type="submit" icon="file-excel" text="Descargar reporte" loading={reportLoading} />
            </Form>
        </div>
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-user"></i></span>
                    <span>Usuario</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-wallet"></i></span>
                    <span>Saldo</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each wallets as wallet, index}
            <tr>
                <td><span>{ metadata?.items != null ? (metadata.items * (query.page ?? 0)) + (index + 1) : index + 1 }</span></td>
                <td>
                    <div class="td-stack">
                        <div>{ wallet.user?.name ?? '—' }</div>
                        <small>{ wallet.user?.email ?? '' }</small>
                    </div>
                </td>
                <td>{ NumeralMethods.cash(wallet.amount) }</td>
            </tr>
        {/each}
    </tbody>
</Table>
